/* globals $ */
'use strict';

$(function () {
  // Create table of content
  let toc = $('.table-of-content');
  if (toc.length > 0) {
    $('.document.content h3').each((_, obj) => {
      let element = $(obj);
      let text = element.text();
      if (element.attr('opti-short')) {
        text = element.attr('opti-short');
      }
      let id = text
        .toLowerCase()
        .split(' ')
        .join('_')
        .replace(/å/g, 'a')
        .replace(/ä/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/[^a-z0-9_]/g, '');

      element.before($(`<span id="${id}" class="page-anchor"></span>`));
      toc
        .find('ul')
        .append($(`<li id="${id}-toc"><a href="#${id}">${text}</a></li>`));
    });

    $(document).scroll(function () {
      toc.find('li').removeClass('selected');

      let closest;
      let currentClosest = 9999;

      $('.page-anchor').each(function () {
        let diff =
          document.documentElement.scrollTop - $(this).offset().top + 32;
        if (diff < currentClosest && diff >= 2) {
          closest = $(this);
          currentClosest = diff;
        }
      });

      let path = location.origin + location.pathname;
      if (closest) {
        const id = closest.attr('id');
        path += '#' + id;
        closest.addClass('selected');
        $('#' + id + '-toc').addClass('selected');
      }

      // Only replace history if changed
      if (location.href !== path) {
        history.replaceState('data', 'title', path);
      }
    });
  }

  $('.graph-container').each((_, el) => {
    let button = $(el).find('.expand-button');
    let expandableContent = $(el).find('.labels-full-container');

    $(button).on('click', () => {
      expandableContent.toggle();
    });
  });
});
